/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { htmlspecialchars, MDLocale } from 'js/entry/util.js';
import { startProgress, stopProgress, postToBackend2 } from 'js/entry/base.js';

import { mjt } from 'js/entry/i18ntexts.js';


/**
 * A voting from inquirers point of view.
 */
class InquirerVoting {
	constructor( voting, media_ids, approver_votes, approver_user_display_data, final_votes ) {
		this.initialize(voting,media_ids,approver_votes,approver_user_display_data,final_votes);
	}

	initialize( voting, media_ids, approver_votes, approver_user_display_data, final_votes ) {
		this.voting = voting;
		this.media_ids = media_ids;
		this.approver_votes = approver_votes;
		this.approver_user_display_data = approver_user_display_data;
		this.final_votes = final_votes;
	}

	getVotingId() {
		return this.voting.voting_id;
	}

	getCountOfSubmittedApproverVotes() {
		var submitted_approver_votes_count = 0;
		for( const approver_user_id in this.approver_votes ) {
			if( !this.approver_votes.hasOwnProperty(approver_user_id) ) continue;
			const approver_vote = this.approver_votes[approver_user_id];
			if( approver_vote.submitted_dt!==null ) submitted_approver_votes_count ++;
		}
		return submitted_approver_votes_count;
	}

	getApproverVotesOfApprover( approver_user_id ) {
		if( !this.approver_votes.hasOwnProperty(approver_user_id) ) return null;
		return this.approver_votes[approver_user_id];
	}

	areAllApproverVotesSubmitted() {
		return this.getCountOfSubmittedApproverVotes() == this.voting.approver_user_ids.length;
	}

	getFeedbackNumbersTextItem() {
		return this.getCountOfSubmittedApproverVotes() + '/' + this.voting.approver_user_ids.length;
	}

	getFeedbackStatusTextItem( unescaped ) {
		if( this.hasFinalVotesSubmitted() ) return mjt('votings-feedback-final-votes-submitted',unescaped?'!':undefined);
		else if( this.hasFinalVotesStarted() ) return mjt('votings-feedback-final-votes-started',unescaped?'!':undefined);
		else if( this.areAllApproverVotesSubmitted() ) return mjt('votings-feedback-approver-votes-fully-submitted',unescaped?'!':undefined);
		return mjt('votings-feedback-approver-votes-in-progress',unescaped?'!':undefined);
	}

	getFeedbackStatusHTMLItemOfApproverVote( approver_user_id ) {
		const approver_vote = this.getApproverVotesOfApprover(approver_user_id);

		var state_name;
		if( approver_vote==null ) state_name = 'none';							// not started yet, not submitted yet	= waiting for vote from approver
		else if( approver_vote.submitted_dt==null ) state_name = 'started';		// started, but not submitted yet		= waiting for vote from approver
		else state_name = 'submitted';											// started & submitted					= approver is done
		// NOTE: approver_vote.started_dt is never null

		const appr_votes_status_html = '<span class="votings-feedback-approver-vote-flag votings-feedback-approver-vote-flag-'+state_name+'"></span>';
		return appr_votes_status_html;
	}



	getShortFeedbackHTML() {
		return this.getFeedbackNumbersTextItem() + '<small> (' + this.getFeedbackStatusTextItem(false) + ')</small>';
	}

	getFullFeedbackHTML() {
		var html = '';
		if( this.voting.expiry_dt!=null ) {
			html += '<span class="box" style="display:inline-block; text-align:right; float:right;">'
					+ '<label>'+mjt('votings-expiry_dt')+'</label><br>\n'
					+ MDLocale.fmt_datetime(this.voting.expiry_dt)
					+'</span>\n';
		}

		html += '<b>'+this.getFeedbackStatusTextItem(false)+'</b><br><br>\n\n';

		// var expiry_dt = this.voting.expiry_dt;
		// if( this.voting.expiry_dt!=null ) {
		// 	html += '<label>'+mjt('votings-expiry_dt')+':</label><br>\n';
		// 	html += MDLocale.fmt_datetime(this.voting.expiry_dt)+'<br><br>\n\n';
		// }

		html += '<label>'+mjt('votings-feedback-state')+':</label><br>\n';
		html += '<ul class="votings-feedback-approver-votes">';
		for( var u=0; u<this.voting.approver_user_ids.length; ++u ) {
			const approver_user_id = this.voting.approver_user_ids[u];
			const user_display_data = this.approver_user_display_data.hasOwnProperty(approver_user_id) ? this.approver_user_display_data[approver_user_id] : { display_name:'user_id='+approver_user_id };
			html += '<li>'
						+ this.getFeedbackStatusHTMLItemOfApproverVote(approver_user_id)
						+ ' '
						+ htmlspecialchars(user_display_data['display-name']||'user_id='+approver_user_id,false,true)
					+'</li>';
		}
		html += '</ul>';
		return html;
	}

	hasFinalVotesStarted() {
		return this.voting.final_votes_started_dt!=null;
	}

	hasFinalVotesSubmitted() {
		return this.voting.final_votes_started_dt!=null && this.voting.final_votes_submitted_dt!=null;
	}

	getFinalVotes() {
		return this.final_votes;
	}

	mergeFinalVotes( media_ids_to_vote_value, onresult ) {
		// // eslint-disable-next-line
		// console.log({ fn:'InquirerVoting::mergeFinalVotes', media_ids_to_vote_value });
		clearInquirerVotingCache(this.voting.voting_id);
		startProgress();
		var postdata = 'voting_id='+encodeURIComponent(this.voting.voting_id);
		for( var media_id in media_ids_to_vote_value ) {
			if( !media_ids_to_vote_value.hasOwnProperty(media_id) ) continue;
			var vote_value = media_ids_to_vote_value[media_id];
			if( vote_value===true || vote_value===false || vote_value==null ) {
				postdata += '&set_final_votes['+encodeURIComponent(media_id)+']=' + (vote_value==null?'':(vote_value?'1':'0'));
			}
		}
		var self = this;
		postToBackend2(
			'json/x_votings_main/inquirer_voting-merge_final_votes',
			postdata,
			function _success( j, jqXHR ) {
				stopProgress();
				if( j && j.hasOwnProperty('voting') ) {
					self.initialize(j.voting,j.media_ids,j.approver_votes,j.approver_user_display_data,j.final_votes);
					if( onresult ) onresult(self);
				}
			},
			function _timeout() {
				stopProgress();
			},
			function _error( jqXHR, textStatus, message ) {
				stopProgress();
			},
			true
			// function _complete( jqXHR, textStatus, self ) {
			// }
		);
	}

	setFinalVotesValue( sel_media_ids, vote_value, onresult ) {
		var media_ids_to_vote_value = {};
		for( var i=0; i<sel_media_ids.length; ++i ) {
			var media_id = sel_media_ids[i];
			media_ids_to_vote_value[media_id] = vote_value==null ? null : !!vote_value;
		}
		this.mergeFinalVotes(media_ids_to_vote_value,onresult);
	}

	setFinalVotesFromApprovalVotes( sel_media_ids, onresult ) {
		var media_ids_to_vote_value = {};
		for( var i=0; i<sel_media_ids.length; ++i ) {
			var media_id = sel_media_ids[i];
			var counts = this.getApprovalVotesForMediaId(media_id);
			if( counts.combined_status==='approved' ) media_ids_to_vote_value[media_id] = true;
			else if( counts.combined_status==='rejected' ) media_ids_to_vote_value[media_id] = false;
			else media_ids_to_vote_value[media_id] = null;
		}
		this.mergeFinalVotes(media_ids_to_vote_value,onresult);
	}

	/**
	 *
	 * @param {Array} sel_media_ids
	 * @returns {?boolean}
	 */
	getFinalVotesCombinedState( sel_media_ids ) {
		var media_id = sel_media_ids[0];
		var last_val = this.final_votes.hasOwnProperty(media_id) ? !!this.final_votes[media_id] : undefined;
		for( var i=1; i<sel_media_ids.length; ++i ) {
			media_id = sel_media_ids[i];
			var vote_val = this.final_votes.hasOwnProperty(media_id) ? !!this.final_votes[media_id] : undefined;
			if( vote_val!==last_val ) {
				// mixed result
				return null;
			}
			last_val = vote_val;
		}
		return last_val;
	}

	/**
	 *
	 * @param {string|number} media_id
	 * @returns {?boolean}
	 */
	getFinalVotesCombinedStateForMediaId( media_id ) {
		return this.final_votes.hasOwnProperty(media_id) ? !!this.final_votes[media_id] : null;
	}

	/**
	 * @returns {Object}	- An object with keys: all, approved, rejected, open, where each value is the count of items in state .. .
	 */
	getAllCombinedFinalVotesGroups() {
		var counts = {
			all: this.media_ids.length,
			approved: 0,
			rejected: 0,
			open: 0,
		};
		for( var i=0; i<this.media_ids.length; ++i ) {
			const cs = this.getFinalVotesCombinedStateForMediaId(this.media_ids[i]);
			const ckey = cs===true ? 'approved' : ( cs===false ? 'rejected' : 'open' );
			counts[ckey] ++;
		}
		return counts;
	}


	/**
	 * @param {string|number} media_id
	 * @returns {Array}
	 */
	getAllApproversVotesOnMediaId( media_id ) {
		let approvers_votes_map = {};
		for( var u=0; u<this.voting.approver_user_ids.length; ++u ) {
			const approver_user_id = this.voting.approver_user_ids[u];
			var users_vote_value = 'unrated';
			if( this.approver_votes.hasOwnProperty(approver_user_id) ) {
				// ok, user has at least "tried" to vote ..
				const approver_vote = this.approver_votes[approver_user_id];
				if( approver_vote.submitted_dt!==null ) {
					// ok, user has actually submitted votes:
					if( approver_vote.votes.hasOwnProperty(media_id) ) {
						const bval = approver_vote.votes[media_id];
						if( bval===true ) users_vote_value = 'approved';
						else if( bval===false ) users_vote_value = 'rejected';
					}
				}
			}
			approvers_votes_map[approver_user_id] = users_vote_value;
		}
		return approvers_votes_map;
	}

	/**
	 * @param {string|number} media_id
	 * @returns {Object}
	 */
	getApprovalVotesForMediaId( media_id ) {
		var counts = {
			approved: 0,
			rejected: 0,
			unrated: 0,
			combined_status: '',
			combined_status_label: ''
		};
		const all_approvers_votes_on_media_id = this.getAllApproversVotesOnMediaId(media_id);
		for( let approver_user_id in all_approvers_votes_on_media_id ) {
			if( !all_approvers_votes_on_media_id.hasOwnProperty(approver_user_id) ) continue;
			const approver_vote_type = all_approvers_votes_on_media_id[approver_user_id];
			counts[approver_vote_type] ++;
		}
		if( counts.approved && counts.rejected ) {
			counts.combined_status = 'ambiguous';
			counts.combined_status_label = mjt('ctx-menu-votings-ambiguous');
		} else if( !counts.approved && !counts.rejected ) {
			counts.combined_status = 'unrated';
			counts.combined_status_label = mjt('ctx-menu-votings-unrated');
		} else if( counts.approved ) {
			counts.combined_status = 'approved';
			counts.combined_status_label = mjt('ctx-menu-votings-approved');
		} else if( counts.rejected ) {
			counts.combined_status = 'rejected';
			counts.combined_status_label = mjt('ctx-menu-votings-rejected');
		}
		return counts;
	}


	/**
	 * @returns {Object}	- An object with media_ids as keys, and counts as value each (see getApprovalVotesForMediaId).
	 */
	getAllCombinedApprovalVotesByMedia() {
		var combined_approval_votes_by_media_id = {};
		var all_involved_media_ids = this.media_ids.slice();
		for( var i=0; i<all_involved_media_ids.length; ++i ) {
			const media_id = all_involved_media_ids[i];
			combined_approval_votes_by_media_id[media_id] = this.getApprovalVotesForMediaId(media_id);
		}
		return combined_approval_votes_by_media_id;
	}


	/**
	 * @returns {Object}	- An object with keys: all, approved, rejected, unrated, ambiguous, where each value is count of items in state .. .
	 */
	getAllCombinedApprovalVotesGroups() {
		var counts = {
			all: this.media_ids.length,
			approved: 0,
			rejected: 0,
			unrated: 0,
			ambiguous: 0,
		};
		for( var i=0; i<this.media_ids.length; ++i ) {
			var cs = this.getApprovalVotesForMediaId(this.media_ids[i]);
			counts[cs.combined_status] ++;
		}
		return counts;
	}


	getFinalVotesResultsHTML( media_ids ) {
		var final_votes = this.getFinalVotes();
		if( media_ids.length===1 ) {
			if( final_votes.hasOwnProperty(media_ids[0]) ) {
				var final_vote = final_votes[media_ids[0]];
				var cs_state, cs_label;
				if( final_vote===true ) {
					cs_state = 'approved';
					cs_label = mjt('ctx-menu-votings-final-votes-approved');
				} else if( final_vote===false ) {
					cs_state = 'rejected';
					cs_label = mjt('ctx-menu-votings-final-votes-rejected');
				} else {
					cs_state = 'unrated';
					cs_label = mjt('ctx-menu-votings-final-votes-unrated');
				}
				return '<span class="final-votes-combined-status final-votes-combined-status-'+cs_state+'">'+cs_label+'</span>';
			}
		}
		return '';
	}


	getApprovalVotersByTypeHTML( media_id, type ) {
		var html = '';
		const all_approvers_votes_on_media_id = this.getAllApproversVotesOnMediaId(media_id);
		for( let approver_user_id in all_approvers_votes_on_media_id ) {
			if( !all_approvers_votes_on_media_id.hasOwnProperty(approver_user_id) ) continue;
			const approver_vote_type = all_approvers_votes_on_media_id[approver_user_id];
			if( approver_vote_type===type ) {
				const user_display_data = this.approver_user_display_data.hasOwnProperty(approver_user_id) ? this.approver_user_display_data[approver_user_id] : { display_name:'user_id='+approver_user_id };
				html += '<span class="approver">' + htmlspecialchars(user_display_data['display-name']||'user_id='+approver_user_id,false,true) + '</span>';
			}
		}
		var tooltip_attrs = html.length ? (' data-mj-custom-tooltip="'+htmlspecialchars('<span class="approver-list">'+html+'</span>',true,true)+'" title="_"') : '';
		return '<span class="approver-list"'+tooltip_attrs+'>' + html + '</span>';
	}


	getApprovalVotesResultsHTML( media_id, extended ) {
		var counts = this.getApprovalVotesForMediaId(media_id);
		var html = '<span class="approver-votes-combined-status approver-votes-combined-status-'+counts.combined_status+'">'+counts.combined_status_label+'</span>';
		html += '<ul class="approver-vote-counts">';

		html += '<li><span class="label">'+mjt('ctx-menu-votings-approved')+': </span><span>'+counts.approved+'</span>';
		if( extended ) html += this.getApprovalVotersByTypeHTML(media_id,'approved');
		html += '</li>';

		html += '<li><span class="label">'+mjt('ctx-menu-votings-rejected')+': </span><span>'+counts.rejected+'</span>';
		if( extended ) html += this.getApprovalVotersByTypeHTML(media_id,'rejected');
		html += '</li>';

		html += '<li><span class="label">'+mjt('ctx-menu-votings-unrated')+': </span><span>'+counts.unrated+'</span>';
		if( extended ) html += this.getApprovalVotersByTypeHTML(media_id,'unrated');
		html += '</li>';

		html += '</ul>';
		return html;
	}
}



var m_inquirer_voting_cache = {};


function queryInquirerVoting( voting_id, success_cb, error_cb ) {
	//startProgress();
	postToBackend2(
		'json/x_votings_main/inquirer_voting-get',
		'voting_id='+encodeURIComponent(voting_id),
		function _success( j, jqXHR ) {
			//stopProgress();
			if( j && j.hasOwnProperty('voting') && j.hasOwnProperty('approver_votes') ) {
				if( success_cb ) {
					const inquirer_voting = new InquirerVoting(j.voting,j.media_ids,j.approver_votes,j.approver_user_display_data,j.final_votes);
					m_inquirer_voting_cache[voting_id] = { inquirer_voting, ts: Date.now() };
					success_cb(inquirer_voting);
				}
			}
		},
		function _timeout() {
			//stopProgress();
		},
		function _error( jqXHR, textStatus, message ) {
			//stopProgress();
			if( error_cb ) error_cb(jqXHR,textStatus,message);
		},
		true
		// function _complete( jqXHR, textStatus, self ) {
		// }
	);
}


var m_inquirer_voting_cache_max_age_ms = 60*1000;

export function queryCachedInquirerVoting( voting_id, success_cb, error_cb ) {
	if( m_inquirer_voting_cache.hasOwnProperty(voting_id) ) {
		var ce = m_inquirer_voting_cache[voting_id];
		if( Date.now() - ce.ts >= m_inquirer_voting_cache_max_age_ms ) {
			delete m_inquirer_voting_cache[voting_id];
		} else {
			setTimeout( function() {
				success_cb(ce.inquirer_voting);
			}, 0 );
			return;
		}
	}
	return queryInquirerVoting(voting_id,success_cb,error_cb);
}


export function clearInquirerVotingCache( voting_id ) {
	if( voting_id == null ) m_inquirer_voting_cache = {};
	else if( m_inquirer_voting_cache.hasOwnProperty(voting_id) ) delete m_inquirer_voting_cache[voting_id];
}



export function finishInquirerVotingApproverVotes( voting_id, onresult ) {
	clearInquirerVotingCache(voting_id);
	startProgress();
	postToBackend2(
		'json/x_votings_main/inquirer_voting-finish_approver_votes',
		'voting_id='+encodeURIComponent(voting_id),
		function _success( j, jqXHR ) {
			stopProgress();
			if( j && j.hasOwnProperty('voting') && j.hasOwnProperty('approver_votes') ) {
				if( onresult ) {
					const inquirer_voting = new InquirerVoting(j.voting,j.media_ids,j.approver_votes,j.approver_user_display_data,j.final_votes);
					m_inquirer_voting_cache[voting_id] = { inquirer_voting, ts: Date.now() };
					onresult(inquirer_voting);
				}
			}
		},
		function _timeout() {
			stopProgress();
		},
		function _error( jqXHR, textStatus, message ) {
			stopProgress();
		},
		true
		// function _complete( jqXHR, textStatus, self ) {
		// }
	);
}


export function submitInquirerVotingFinalVotes( voting_id, onresult ) {
	clearInquirerVotingCache(voting_id);
	startProgress();
	postToBackend2(
		'json/x_votings_main/inquirer_voting-submit_final_votes',
		'voting_id='+encodeURIComponent(voting_id),
		function _success( j, jqXHR ) {
			stopProgress();
			if( j && j.hasOwnProperty('voting') && j.hasOwnProperty('approver_votes') ) {
				if( onresult ) {
					const inquirer_voting = new InquirerVoting(j.voting,j.media_ids,j.approver_votes,j.approver_user_display_data,j.final_votes);
					m_inquirer_voting_cache[voting_id] = { inquirer_voting, ts: Date.now() };
					onresult(inquirer_voting);
				}
			}
		},
		function _timeout() {
			stopProgress();
		},
		function _error( jqXHR, textStatus, message ) {
			stopProgress();
		},
		true
		// function _complete( jqXHR, textStatus, self ) {
		// }
	);
}


export function getCombinedApprovalVotesStatusTypes( pfx ) {
	return [
		pfx+'approved',
		pfx+'rejected',
		pfx+'unrated',
		pfx+'ambiguous',
	];
}


